import { ADDRESS_HOME, ADDRESS_OTHER, ADDRESS_WORK } from 'containers/pages/contacts/constants';

function makeAddress(madeAddressForm, addressType, contact) {
	if (addressType === ADDRESS_WORK) {
		madeAddressForm.type = '4';
		madeAddressForm.address_id = contact.addressWork.address_id;
	} else if (addressType === ADDRESS_HOME) {
		madeAddressForm.type = '5';
		madeAddressForm.address_id = contact.addressHome.address_id;
	} else if (addressType === ADDRESS_OTHER) {
		madeAddressForm.type = '6';
		madeAddressForm.address_id = contact.addressOther.address_id;
	}
	return madeAddressForm;
}

export default makeAddress;
